/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBluetooth: {
  name: 'bluetooth';
  data: string;
} = {
  name: 'bluetooth',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.507 3.13a1 1 0 0 1 1.008.013l5 3a1 1 0 0 1 .192 1.564L13.414 12l4.293 4.293a1 1 0 0 1-.192 1.565l-5 3A1 1 0 0 1 11 20v-5.586l-3.293 3.293a1 1 0 0 1-1.414-1.414L10.586 12 6.293 7.707a1 1 0 0 1 1.414-1.414L11 9.586V4a1 1 0 0 1 .507-.87ZM13 14.414l2.387 2.388L13 18.233v-3.82Zm0-4.828v-3.82L15.387 7.2 13 9.586Z" fill="currentColor"/></svg>`,
};
